import React, { FC, Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Grid, TextField, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import SecurityIcon from '@material-ui/icons/Security';

import { ValidatedTextField } from 'components';
import ChangePassword from './ChangePassword';

const useStyles = makeStyles(() => ({
  button: {
    position: 'relative',
    top: 28,
  },
}));

const Access: FC = () => {
  const classes = useStyles();
  const [passwordOpen, setPasswordOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <Fragment>
      <Grid container>
        <Grid item xs={3}>
          <Grid container alignItems="center" spacing={2}>
            <Grid item>
              <SecurityIcon color="action" />
            </Grid>
            <Grid item>
              <Typography variant="subtitle2">{t('common:access')}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs>
          <Grid container spacing={5}>
            <Grid item xs>
              <ValidatedTextField
                TextFieldProps={{ margin: 'none', disabled: true }}
                persistLabel
                name="email_address"
                i18nKey="user:email"
              />
            </Grid>
            <Grid item xs>
              <Grid container spacing={2}>
                <Grid item xs>
                  <TextField
                    fullWidth
                    margin="none"
                    type="password"
                    value="Dummy Text"
                    label={t('common:password')}
                    inputProps={{ disabled: true }}
                  />
                </Grid>
                <Grid item>
                  <Button
                    variant="outlined"
                    fullWidth
                    className={classes.button}
                    onClick={() => setPasswordOpen(true)}
                  >
                    {t('common:change')}
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <ChangePassword open={passwordOpen} onClose={() => setPasswordOpen(false)} />
    </Fragment>
  );
};

export default Access;
